import { useContext } from 'react';
import { AppFeatureFlagsContext, IAppFeatureFlagsContext } from 'context';

export function useAppFeatureFlags(): IAppFeatureFlagsContext {
  return useContext(AppFeatureFlagsContext)!;
}
